/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import data from "./data";
import ServerRequest from "./server-request";
import urlJoin from "proper-url-join";

export default {
  async get(articleIdOrSlug) {
    const request = new ServerRequest(
      urlJoin(process.env.VUE_APP_BACKEND_URL, `articles/${articleIdOrSlug}`)
    );
    try {
      let response = await request.get();
      return response.data;
    } catch (e) {
      console.error(`Unable to load article ${articleIdOrSlug}`, e);
      throw e;
    }
    // return new Promise(resolve => {
    //   setTimeout(() => {
    //     let items = data.articles.filter(
    //       article => article.slug === articleIdOrName
    //     );
    //     if (items.length === 1) {
    //       return resolve(items[0]);
    //     }
    //     throw new Error("article not found!");
    //   }, Math.random() * 500 + 500);
    // });
  },
  getByTag(tagName) {
    return new Promise(resolve => {
      setTimeout(() => {
        return resolve(
          data.articles.filter(article => article.tags.includes(tagName))
        );
      }, Math.random() * 500 + 500);
    });
  }
};
